

export default function useOptimizedList(update, remove) {
    return {
        list(state, list) {
            state.list = list;
            list.forEach((item, index) => {
                state.listMap[item.id.toString()] = index;
            });
        },

        clearList(state) {
            state.list = [];
            state.listMap = {};
        },

        addToList(state, item) {
            state.list.push(item);
            state.listMap[item.id.toString()] = state.list.length - 1;
        },

        updateOrAddOnlyInList(state, item) {
            const index = state.listMap[item.id.toString()];
            if (typeof index !== 'undefined') {
                return update(state, index, item);
            }
            state.list.push(item);
            state.listMap[item.id.toString()] = state.list.length - 1;
        },

        prependToList(state, item) {
            state.list.unshift(item);

            state.listMap = {};
            state.list.forEach((item, index) => {
                state.listMap[item.id.toString()] = index;
            });
        },

        updateOrAddToList(state, item) {
            const index = state.listMap[id.toString()];
            if (typeof index !== 'undefined') {
                return update(state, index, item);
            }
            state.list.push(item);
            state.listMap[item.id.toString()] = state.list.length - 1;
        },

        removeFromList(state, ids) {
            (Array.isArray(ids) ? ids : [ids]).forEach((id) => {
                const index = state.listMap[id.toString()];
                if (typeof index === 'undefined') return;
                remove(state, index);
            });
        },

        updateInList(state, item) {
            const index = state.listMap[item.id.toString()];
            if (typeof index === 'undefined') return;
            update(state, index, item);
        },
    }
}